import { configureStore } from '@reduxjs/toolkit';
import fileSlice from './modules/builder/features/files';
import uiReducer from './uiSlice';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('uiState');
    if (!serializedState) return undefined;

    const parsedState = JSON.parse(serializedState);

    // Ensure activeSubTab is an object
    if (typeof parsedState.activeSubTab !== 'object' || Array.isArray(parsedState.activeSubTab)) {
      return undefined; // fallback to initial state
    }

    return parsedState;
  } catch {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('uiState', serializedState);
  } catch (e) {
    // ignore errors
  }
};

const store = configureStore({
  reducer: {
    file: fileSlice,
    ui: uiReducer
  },
  preloadedState: {
    ui: loadState()
  }
});

store.subscribe(() => {
  saveState(store.getState().ui);
});

export default store;
